import { render, staticRenderFns } from "./BookingsTable.vue?vue&type=template&id=653fef94&scoped=true"
import script from "./BookingsTable.vue?vue&type=script&lang=ts"
export * from "./BookingsTable.vue?vue&type=script&lang=ts"
import style0 from "./BookingsTable.vue?vue&type=style&index=0&id=653fef94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653fef94",
  null
  
)

export default component.exports